<template>
  <div>
    <el-card>
      <div class="join_box">
        <p class="desc_title">
          <i class="circle"></i> 核实考勤
        </p>
        <p class="desc_title">
          <i class="circle"></i> 核实借款押金是否收回
        </p>
        <p class="desc_title">
          <i class="circle"></i> 需回收装备：
        </p>
        <div class="info_title">
          公司装备：
          <template v-if="material.length>0">
            <span v-for="item in material" :key="item.id">
              <span v-if="item.configureType == 0" class="name">{{item.materialName}}({{item.num}})</span>
            </span>
          </template>
          <span v-else>无</span>
        </div>
        <p class="info_title">
          客户装备：
          <template v-if="material.length>0">
            <span v-for="item in material" :key="item.id">
              <span v-if="item.configureType == 1">
                <span v-if="item.materialName" class="name">{{item.materialName}}({{item.num}})</span>
              </span>
            </span>
          </template>
          <span v-else>无</span>
        </p>
      </div>
    </el-card>
    
    <div v-if="Object.prototype.toString.call(staffDetail.records) === '[object Array]' && staffDetail.records.length > 1">
      <div v-for="item in staffDetail.records" :key="item.id" class="marb15">
        <card-brief-approvla :item="item" type="1"></card-brief-approvla>
      </div>
    </div>
   
    <div v-if="Object.prototype.toString.call(staffDetail.records) === '[object Object]'">
      <card-brief-approvla :item="staffDetail.records" type="1"></card-brief-approvla>
    </div> 
  </div>
</template>

<script>
export default {
  name: "CardBriefJoin", // 交接以后
  props: ["staffDetail"],
  data() {
    return {
      material: []
    };
  },
  created() {
    if (this.staffDetail && this.staffDetail.handover) {
      this.material = this.staffDetail.handover.material;
    }
  }
};
</script>

<style lang="scss" scoped>
.join_box {
  .desc_title {
    padding-bottom: 6px;
    line-height: 28px;
    .circle {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #999;
      border-radius: 8px;
      margin-right: 6px;
    }
  }
  .info_title {
    line-height: 28px;
    text-indent: 16px;
  }
}
.name {
  padding: 0 10px 0 0;
}
</style>